import React from 'react';
import CCVendors from './CreditCard/CCVendors';
import CashSVG from './assets/cash.svg';
import eftSvg from './assets/EFT.svg';
import payidPng from './PAYID/PayID_icon.png';
import bpaySvg from './BPAY/Bpay-logo.svg';

export const PaymentMethods = {
	Card: 1,
	Bpay: 3,
	Eft: 4,
	Cash: 5,
	'Apple Pay': 12,
	'Google Pay': 13,
	PayID: 14,
};

export enum PaymentPages {
	Home,
	Select,
	Card,
	NewCard,
	Eft,
	Cash,
	Map,
	BPay,
	PayID,
}

export const ConvertPaymentTypeToView = (paymentType: { id: number; name: string }) => {
	// using if instead of switch to handle checking ID and name
	if (paymentType.id === PaymentMethods.Card)
		return { id: 1, name: 'Debit Card', icon: <CCVendors height={15} width={85} /> };
	if (paymentType.id === PaymentMethods.PayID)
		return { id: 2, name: 'PayID', icon: <img src={payidPng} alt="payid" /> };
	if (paymentType.id === PaymentMethods.Bpay) return { id: 3, name: 'BPAY', icon: <img src={bpaySvg} alt="bpay" /> };
	if (paymentType.id === PaymentMethods.Eft) return { id: 4, name: 'EFT', icon: <img src={eftSvg} alt="eft" /> };
	if (paymentType.id === PaymentMethods.Cash)
		return { id: 5, name: 'Cash in-store', icon: <img src={CashSVG} alt="cash" /> };
	return { id: 1, name: 'Debit Card', icon: <CCVendors /> };
};

export interface DepositPage {
	pageIndex: number;
	subTitle?: string;
	previousPageIndex?: number;
	body: any; // this is a function that returns a node, but not a functional component
}
